// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Restaumatic_Form_Delayed from "../Restaumatic.Form.Delayed/index.js";
import * as Restaumatic_Form_Final from "../Restaumatic.Form.Final/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Restaumatic_Form_Query from "../Restaumatic.Form.Query/index.js";
import * as Restaumatic_Storage from "../Restaumatic.Storage/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
var bind = /* #__PURE__ */ Control_Bind.bind(Specular_FRP_Host.bindHost);
var liftEffect = /* #__PURE__ */ Effect_Class.liftEffect(Specular_FRP_Host.monadEffectHost);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(Specular_FRP_Host.bindHost);
var for_ = /* #__PURE__ */ Data_Foldable.for_(Specular_FRP_Host.applicativeHost)(Data_Foldable.foldableMaybe);
var subscribeDyn_ = /* #__PURE__ */ Specular_FRP_Base.subscribeDyn_(/* #__PURE__ */ Specular_FRP_Base.monadFRP(Specular_FRP_Host.monadEffectHost)(Specular_FRP_Host.monadCleanupHost));
var traverse_ = /* #__PURE__ */ Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe);
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Host.applicativeHost);
var PersistentInitializer = /* #__PURE__ */ (function () {
    function PersistentInitializer(value0, value1, value2) {
        this.value0 = value0;
        this.value1 = value1;
        this.value2 = value2;
    };
    PersistentInitializer.create = function (value0) {
        return function (value1) {
            return function (value2) {
                return new PersistentInitializer(value0, value1, value2);
            };
        };
    };
    return PersistentInitializer;
})();
var initializePersistentIniti = function (dictInitialize) {
    var makeImpl = Restaumatic_Form_Internal.makeImpl(dictInitialize);
    return function (dictDecode) {
        var getItem = Restaumatic_Storage.getItem(dictDecode);
        return function (dictEncode) {
            var setItem = Restaumatic_Storage.setItem(dictEncode);
            return function (dictMerge) {
                var merge = Restaumatic_Form_Internal.merge(dictMerge);
                return function (dictQuery) {
                    var queryLax = Restaumatic_Form_Query.queryLax(dictQuery);
                    return function (dictHasFieldId) {
                        var getFieldId = Restaumatic_Form_Internal.getFieldId(dictHasFieldId);
                        return {
                            makeImpl: function (s) {
                                return function (opts) {
                                    return function (meta) {
                                        return function (iv) {
                                            return function (v) {
                                                return bind(makeImpl(s)(opts)(meta)(iv)(v.value2))(function (field) {
                                                    var key = Data_Maybe.fromMaybe(getFieldId(field))(v.value1);
                                                    return bind(liftEffect(getItem(v.value0)(key)))(function (m_initialValue) {
                                                        return discard(for_(m_initialValue)(function (initialValue) {
                                                            return liftEffect(merge(initialValue)(field));
                                                        }))(function () {
                                                            return discard(Restaumatic_Form_Delayed.afterInitialized(Data_Function.flip(subscribeDyn_)(Restaumatic_Form_Final.unFinal(queryLax(field)))(traverse_(function (value) {
                                                                return setItem(v.value0)(key)(value);
                                                            }))))(function () {
                                                                return pure(field);
                                                            });
                                                        });
                                                    });
                                                });
                                            };
                                        };
                                    };
                                };
                            }
                        };
                    };
                };
            };
        };
    };
};
var persistentAtKey = function (storage) {
    return function (key) {
        return PersistentInitializer.create(storage)(new Data_Maybe.Just(key));
    };
};
var persistent = function (storage) {
    return PersistentInitializer.create(storage)(Data_Maybe.Nothing.value);
};
export {
    PersistentInitializer,
    persistent,
    persistentAtKey,
    initializePersistentIniti
};
